module.exports = __webpack_public_path__ + "static/media/search.809a3bd8.svg";